import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import styled from "styled-components";
import { calcRem } from "styles/theme";
import { FLEX } from "styles/flex";
import {
  AlertList,
  AlertViewInfo,
} from "api/interfaces/alertInterface.interface";
import * as s from "components/blocks/modalheader/ModalHeaderStyled";
import { useRef } from "react";
import NormalConfirmModal from "../confirm/normal";
import useApiError from "hook/useApiError";
type Props = {
  isAll?: boolean;
  onConfirmCancel: () => void;
  onConfirmOk: (checked: boolean) => void;
  alertInfo: AlertViewInfo;
  currentAlert: AlertList;
  onChangeConfirm?: (e: any) => void;
};

export default function AlertChangeConfirm({
  isAll,
  onConfirmCancel,
  onConfirmOk,
  alertInfo,
  currentAlert,
  onChangeConfirm,
}: Props): JSX.Element {
  const checkboxRef = useRef<any>(null);
  const { lang, intlString } = useApiError();

  return (
    <NormalConfirmModal
      onConfirmCancel={onConfirmCancel}
      onConfirm={() => {
        onConfirmOk(isAll ? false : checkboxRef.current.checked ? true : false);
      }}
    >
      <DeleteTextWrapper>
        <Text fontSize={20} bold color={COLORS.COMPANY}>
          <strong>
            {alertInfo.mergedSystemName !== undefined
              ? alertInfo.mergedSystemName
              : alertInfo.recorderName}
          </strong>
          {alertInfo.type === "Video Loss" && currentAlert.camera
            ? currentAlert.camera.cameraName !== undefined &&
              currentAlert.camera.cameraName === ""
              ? ` [ ${currentAlert.camera.channel} ]`
              : ` [ ${currentAlert.camera.cameraName} ]`
            : ""}
        </Text>
        <Text fontSize={18} bold>
          {intlString(lang.alert.popup.label.confirm.message)}
        </Text>
        {!isAll && (
          <CheckConfirm>
            <label>
              <input
                type="checkbox"
                ref={checkboxRef}
                key={"alert_change_check"}
                defaultChecked={false}
                onChange={onChangeConfirm}
                data-testid="templates-modal-alert-input-change-confirm"
              />

              <Text fontSize={14}>
                {intlString(lang.alert.popup.label.confirm.check)}
              </Text>
            </label>
          </CheckConfirm>
        )}
      </DeleteTextWrapper>
    </NormalConfirmModal>
  );
}
export const DeleteTextWrapper = styled.div`
  text-align: center;
  padding-top: 20px;
  line-height: ${calcRem(28)};
  width: 100%;
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  gap: 5px;
`;

const CheckConfirm = styled(s.Row)`
  padding-top: 18px;
`;
